import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { paymentSummary } from './pricing';

const Block = ({ label, children }) => (
  <div className="min-w-0 space-y-0.5">
    <p className="font-semibold text-foreground">{label}</p>
    <div className="text-muted-foreground leading-snug break-words">{children}</div>
  </div>
);

/** Récapitulatif de l'envoi : se remplit au fil des étapes. */
const SummaryBar = ({ form, totals, variant = 'partner' }) => {
  const { t, language } = useLanguage();
  const isMaritime = form.transport_mode === 'maritime';
  const hasRoute = form.destination_country;
  const hasSender = form.sender.name || form.sender.phone;
  const hasRecipient = form.recipient.name || form.recipient.phone;
  // Le règlement vit dans chaque colis : le récapitulatif le résume.
  const payments = paymentSummary(form.items);
  const hasPayment = payments.hasAny;

  if (!hasRoute && !hasSender && !hasRecipient && !hasPayment) return null;

  return (
    <div className="rounded-lg border border-border bg-muted/40 p-3 text-xs">
      <p className="mb-2 font-semibold text-foreground">
        {language === 'en' ? 'Shipment summary' : 'Résumé de l\'envoi'}
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {hasRoute && (
          <Block label={language === 'en' ? 'Route' : 'Trajet'}>
            <div>{form.origin_country || '—'} → {form.destination_country}</div>
            {form.destination_city && <div>{form.destination_city}</div>}
          </Block>
        )}
        {hasSender && (
          <Block label={language === 'en' ? 'Sender' : 'Expéditeur'}>
            <div>{form.sender.name}</div>
            <div>{form.sender.phone}</div>
          </Block>
        )}
        {hasRecipient && (
          <Block label={language === 'en' ? 'Recipient' : 'Destinataire'}>
            <div>{form.recipient.name}</div>
            <div>{form.recipient.phone}</div>
          </Block>
        )}
        <Block label={language === 'en' ? 'Packages' : 'Colis'}>
          <div>
            {totals.count} {language === 'en' ? (totals.count > 1 ? 'packages' : 'package') : 'colis'}
          </div>
          <div>
            {isMaritime
              ? `${totals.volumeCbm.toFixed(4)} CBM`
              : `${totals.weight.toFixed(2)} kg`}
          </div>
        </Block>
        {hasPayment && (
          <Block label={t('paymentStatus')}>
            <div>
              {[
                payments.paid && `${payments.paid} ${language === 'en' ? 'paid' : 'réglé(s)'}`,
                payments.advance && `${payments.advance} ${language === 'en' ? 'with advance' : 'avancé(s)'}`,
                payments.unpaid && `${payments.unpaid} ${language === 'en' ? 'unpaid' : 'à régler'}`,
              ].filter(Boolean).join(' · ')}
            </div>
            {payments.methods.length > 0 && <div>{payments.methods.join(', ')}</div>}
          </Block>
        )}
      </div>
      {variant === 'partner' && totals.price > 0 && (
        <div className="mt-3 flex flex-wrap items-baseline justify-between gap-2 rounded-md border border-green-200 bg-green-50 px-3 py-2 text-sm text-green-900">
          <span className="font-semibold">Total : {totals.price.toFixed(2)} €</span>
          <span>
            {language === 'en' ? 'Paid' : 'Réglé'} {totals.paid.toFixed(2)} € ·{' '}
            {language === 'en' ? 'due' : 'reste'} {totals.due.toFixed(2)} €
          </span>
        </div>
      )}
    </div>
  );
};

export default SummaryBar;
